import { render, staticRenderFns } from "./XSEEDAcademyQuestions.vue?vue&type=template&id=1d241a48&scoped=true&"
import script from "./XSEEDAcademyQuestions.vue?vue&type=script&lang=js&"
export * from "./XSEEDAcademyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./XSEEDAcademyQuestions.vue?vue&type=style&index=0&id=1d241a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d241a48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAppBar,VCard,VCardText,VCardTitle,VCol,VDialog,VProgressCircular,VRow,VSelect,VSheet})
